export const HESTIA_MARKETING_FEATURE_FLAG = 'hermes.hestiaMarketing'

export const MARKETING_AUTOMATED_CAMPAIGN_TYPE_TABS_FLAG =
  'hermes.marketingAutomatedCampaignTypeTabs'
